import { Ano } from './ano';
import { Realizado } from './realizado';
import { Classificacao } from './classificacao';

/** Dados de um tipo de classificação nos KPIs de produtividade */
export class TipoClassificacao {
    id: number;
    codigo: number;
    nivel: number;
    nome: string;
    anos: Ano[];
    classificacoes: Classificacao[];
    orcamentos: Realizado;
    orcamentosPerdidos: Realizado;
    pedidos: Realizado;

    constructor(props: Partial<TipoClassificacao>) {
        Object.assign(this, props);
        // Anos
        this.constructorAnos(props?.anos ?? []);
        // Classificações
        this.constructorClassificacoes(props?.classificacoes ?? []);
        // Orçamentos
        this.orcamentos = new Realizado(props?.orcamentos ?? null);
        // Orçamentos Perdidos
        this.orcamentosPerdidos = new Realizado(props?.orcamentosPerdidos ?? null);
        // Pedidos
        this.pedidos = new Realizado(props?.pedidos ?? null);
    }

    /** Constructor para os anos */
    private constructorAnos(anos: Ano[]) {
        if (anos && Array.isArray(anos)) {
            this.anos = anos.map(ano => new Ano(ano));
        } else {
            this.anos = [];
        }
    }

    /** Constructor para as clasificações */
    private constructorClassificacoes(classificacoes: Classificacao[]) {
        if (classificacoes && Array.isArray(classificacoes)) {
            this.classificacoes = classificacoes.map(classificacao => new Classificacao(classificacao));
        } else {
            this.classificacoes = [];
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): TipoClassificacao {
        return new TipoClassificacao(JSON.parse(json));
    }
}
